// #region imports

// --- Angular
import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

// --- HS Code
import {
  ChartClickResponse,
  ResultsStatuses,
  ResultsViews,
  SurveyResponseTypes,
  SurveyStatuses,
  SurveySummaryModel,
} from '../../../models';
import { GoogleAnalyticsService } from '../../../core/services/google-analytics.service';

// #endregion

@Component({
  selector: 'hs-results-strip',
  templateUrl: './results-strip.component.html',
  styleUrls: ['./results-strip.component.scss'],
})
export class ResultsStripComponent implements OnInit {
  [x: string]: any;
  @Input() surveyResponse: SurveySummaryModel | null = null;

  @Output() viewChange = new EventEmitter<ResultsViews>();
  @Output() openResultsHint = new EventEmitter();
  @Output() toggleCompareResultsModal = new EventEmitter<boolean>();
  @Output() exploreResults = new EventEmitter<ChartClickResponse>();

  surveyStatuses = SurveyStatuses;
  resultsStatuses = ResultsStatuses;
  responseTypes = SurveyResponseTypes;
  ResultsViews = ResultsViews;
  currentView: ResultsViews = ResultsViews.chart;

  constructor(private googleAnalyticsService: GoogleAnalyticsService) {}

  ngOnInit() {
    this.viewChange.emit(ResultsViews.chart);
    this.currentView = ResultsViews.chart;
  }

  onChartClick(): void {
    this.viewChange.emit(ResultsViews.chart);
    this.currentView = ResultsViews.chart;
  }

  onGridClick(): void {
    this.viewChange.emit(ResultsViews.grid);
    this.currentView = ResultsViews.grid;
  }

  openResultsHintModalClick() {
    this.openResultsHint.emit();
  }

  onToggleCompareResultsModal() {
    this.googleAnalyticsService.eventEmitter(
      'compare_results',
      'dashboard',
      'start_compare'
    );
    this.toggleCompareResultsModal.emit(true);
  }

  onExploreResults() {
    if (this.surveyResponse) {
      this.googleAnalyticsService.eventEmitter(
        'explore_results',
        'dashboard',
        'start_explore'
      );
      this.exploreResults.emit({
        responseType: this.responseTypes.self,
        selectedSurvey: this.surveyResponse,
      });
    }
  }
}
